import React, { useEffect, useState } from "react";
import deleteIcon from "../../assets/icons/delete-bin.svg";
import { FileDownloadCommentView } from "./fields/file-view-field";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { CommentFileUploadField } from "./fields/file-upload-field";
import axios from "axios";
import { url } from "../../config";
import successToast from "../toast/successToast";
import errorToast from "../toast/errorToast";
import ImageViewModal from "../modal/image-view-modal";

const FileCommentComponent = ({ tableName, viewId }) => {
  const [fileData, setFileData] = useState([]);
  const [viewModalOpen, setviewModalOpen] = useState(false);
  const [selectedOpen, setselectedOpen] = useState(null);

  const initialValues = {
    comment: "",
  };

  const validationSchema = Yup.object().shape({});

  const fileCommentsList = () => {
    const token = localStorage.getItem("accessToken");

    axios
      .post(
        `${url}/ffadmin/list-file-comment`,
        {
          model_name: tableName,
          record_id: viewId,
        },
        {
          headers: {
            "x-access-token": token,
          },
        }
      )
      .then((res) => {
        setFileData(res?.data?.data || []);
      })
      .catch((err) => {
        console.error("API Error:", err);
      });
  };

  const deleteFileComment = (id) => {
    const token = localStorage.getItem("accessToken");

    axios
      .post(
        `${url}/ffadmin/delete-file-comment`,
        { id },
        {
          headers: {
            "x-access-token": token,
          },
        }
      )
      .then((res) => {
        successToast(res.message);
        fileCommentsList();
      })
      .catch((err) => {
        errorToast(err?.response?.data?.message || "Delete failed");
      });
  };

  useEffect(() => {
    fileCommentsList();
  }, [tableName, viewId]);

  const isImage = (url) => {
    return /\.(jpeg|jpg|gif|png|webp|bmp|svg)$/i.test(url);
  };

  return (
    <section className="my-10">
      <ImageViewModal
        isOpen={viewModalOpen}
        onClose={() => setviewModalOpen(false)}
        url={selectedOpen}
      />

      <div className="flex justify-between items-center mb-5 bg-background pb-2 z-10">
        <h2 className="text-fs_18 font-semibold capitalize">File Comments</h2>
      </div>

      <section>
        {fileData?.map((item, index) => (
          <div key={index} className="flex items-center gap-1 my-4">
            <FileDownloadCommentView
              viewShow={isImage(item?.url)}
              urlData={item?.url}
              onBtnClick={() => {
                setviewModalOpen(true);
                setselectedOpen(item?.url);
              }}
            />
            <button
              type="button"
              onClick={() => deleteFileComment(item?.id)}
              className="bg-errorColor rounded-full p-3"
            >
              <img src={deleteIcon} width={18} height={18} />
            </button>
          </div>
        ))}
      </section>

      <section className="w-full max-w-[30rem]">
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={() => {}}
          enableReinitialize={true}
        >
          <Form>
            <CommentFileUploadField
              label={"comment"}
              name={"comment"}
              placeholder={`Enter comment`}
              tableName={tableName}
              viewId={viewId}
              setFileData={setFileData}
              fileData={fileData}
            />
          </Form>
        </Formik>
      </section>
    </section>
  );
};

export default FileCommentComponent;
